export const LEVELS = {
  PREPARATORY: 'preparatory',
  STANDARD: 'standard',
  LEADING: 'leading'
}

export const INDICATOR_TYPES = {
  NUMBER: 'number',
  COMPLEX: 'complex',
  YES_NO: 'yes_no',
  MULTI_SELECT: 'multi_select',
  MANUAL_REVIEW: 'manual_review'
}

export const EVALUATION_MODES = {
  AUTOMATIC: 'automatic',
  MANUAL: 'manual',
  HYBRID: 'hybrid'
}

export const ASSESSMENT_STATUS = {
  NOT_STARTED: 'not_started',
  IN_PROGRESS: 'in_progress',
  PASSED: 'passed',
  FAILED: 'failed'
}

export const REVIEW_STATUS = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  NEED_MORE_INFO: 'need_more_info'
}

export const RESULT_STATUS = {
  PASSED: 'passed',
  FAILED: 'failed',
  NOT_REQUIRED: 'not_required',
  PENDING_REVIEW: 'pending_review'
}
